import Head from 'next/head';
import previewLetslink from '../../public/preview/preview-letslink.jpg';
import 'animate.css';
import { Footer, Header } from '../../components';
import LetsLinkPages from './lets-link-pages';
import menu from '../../utils/menu';

export default function LetsLink() {
  return (
    <>
      <Head>
        <title>
          LinkApp: Our Powerful Team Messaging App Simplifies Communication and
          Collaboration
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
          rel="stylesheet"
        />

        <meta
          property="og:title"
          content="LinkApp: Our Powerful Team Messaging App Simplifies Communication and
          Collaboration"
        />
        <meta property="og:image" content={`${previewLetslink.src}`} />
        <meta name="twitter:image" content={`${previewLetslink.src}`} />
        <meta
          property="og:image:alt"
          content="LinkApp: Our Powerful Team Messaging App Simplifies Communication and
          Collaboration"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="LinkApp, our sophisticated team messaging software, streamlines communication and collaboration in your business. LinkApp connects teams via instant messaging, file sharing, audio and video conferencing, and more. Discover LinkApp's real-time alerts, channel-based chats, task management, and productivity tool integration. LinkApp's simple UI and powerful features boost team productivity. Mavinx LinkApp helps your team operate smarter and better."
        />
        <meta
          name="description"
          content="LinkApp, our sophisticated team messaging software, streamlines communication and collaboration in your business. LinkApp connects teams via instant messaging, file sharing, audio and video conferencing, and more. Discover LinkApp's real-time alerts, channel-based chats, task management, and productivity tool integration. LinkApp's simple UI and powerful features boost team productivity. Mavinx LinkApp helps your team operate smarter and better."
        />
        <meta
          name="keywords"
          content="LinkApp, team messaging app, communication app, collaboration tool, instant messaging, file sharing, voice and video calls, real-time notifications, channel-based conversations, task management, productivity tools integration, team productivity, team efficiency, intuitive interface, robust functionality, work smarter, Mavinx communication solution"
        />
      </Head>
      <Header
        appearance="transparent"
        appearanceLogo="letslink"
        appearanceNav="letslink"
        menu={menu}
      />
      <LetsLinkPages />
      <Footer line="letslink" logo="letslink" variant="letslink" />
    </>
  );
}
